import { Dialog, Transition } from '@headlessui/react';
import { Fragment, ReactNode } from 'react';

export interface ModalActionData {
  type: 'primary' | 'secondary';
  title: string;
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
}

export type ModalActionsAlignment = 'start' | 'end' | 'stretch';

interface Props {
  open: boolean;
  onClose: () => void;
  children?: ReactNode;
}

export default function ImageLibraryModalWrapper({
  open,
  onClose,
  children,
}: Props) {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500/75 transition-opacity" />
        </Transition.Child>
        <div className="fixed inset-0 z-999 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel
                className={
                  'relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 w-full max-w-5xl h-[850px]'
                }
                style={{
                  maxHeight: 'calc(100vh - 100px)',
                  overflowY: 'hidden',
                }}
              >
                {children}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
